export const Assets = {
  All             : [],
  Currencies      : [],
  CommonCurrencies: [],
  Commodities     : []
}
